module.exports = __webpack_public_path__ + "static/media/iconmonstr-delivery-5.4cef2f96.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/iconmonstr-delivery-5.svg
// module id = 721
// module chunks = 0